<template>
  <div id="app">
    <Head/>
    <router-view ref="routerViewRef"/>
    <Foot @scrollToPageEl="scrollToPageEl"/>
  </div>
</template>

<script>
import Head from '@/components/Head';
import Foot from '@/components/Foot'

import eventBus from '@/utils/eventBus';

export default {
  name: 'app',
  components: {
    Head,
    Foot
  },
  data() {
    return {}
  },
  methods: {
    scrollToPageEl(elementId) {
      // // 1. 简单路由判断：仅目标路由触发事件（按需修改）
      // const targetRoutes = ['TargetPage1', 'TargetPage2']; // 目标路由name
      // if (!targetRoutes.includes(this.$route.name)) {
      //   console.warn('当前路由无需执行scrollToEl');
      //   return;
      // }

      // 2. 触发事件：目标页面会自动执行scrollToEl（无需找实例！）
      eventBus.$emit('scrollToPageEl', elementId);
    }
  }
}
</script>

<style>
</style>
